export const SET_TIMELINE_LOADING = 'SET_TIMELINE_LOADING'
export const GET_TIMELINE_DATA = 'GET_TIMELINE_DATA'
export const CLEAR_TIMELINE_DATA = 'CLEAR_TIMELINE_DATA'
